import type { MakeStylesHook, StyleRules } from '@egr/xbox/utils/tss-react';
import type * as React from 'react';

import logo from '../images/male.svg';
import { errorMessageStore } from '../stores/ErrorMessageStore';

import Wrapper from './Wrapper';

import { makeStyles } from '@egr/xbox/utils/tss-react';

type WrapperStyleRules = 'root' | 'image' | 'message' | 'description';

function styles(): StyleRules<WrapperStyleRules> {
    return {
        root: {
            position: 'absolute',
            zIndex: 3,
            backgroundColor: '#BDCEC6',
            alignContent: 'center',
        },
        image: {
            verticalAlign: 'top',
            maxWidth: 'calc(100% - 40px)',
            width: 400,
        },
        message: {
            color: '#C00303',
            fontWeight: 400,
            fontSize: 24,
            margin: '31px 0 0',
        },
        description: {
            margin: '7px 0 0',
            fontSize: 14,
        },
    };
}

const useStyles: MakeStylesHook<WrapperStyleRules> = makeStyles({ name: 'App' })(styles);

const ErrorMessage: React.FC = () => {
    const { classes } = useStyles();
    const { show, error } = errorMessageStore.useState(['show', 'error']);

    if (show) {
        return (
            <Wrapper className={classes.root}>
                <img
                    src={logo}
                    className={classes.image}
                    data-testid="errorImage"
                />
                <h1 className={classes.message}>{error?.message}</h1>
                <p className={classes.description}>{error?.description}</p>
            </Wrapper>
        );
    }
    return null;
};

export default ErrorMessage;
